import { getEntry as realGetEnry } from './getters';
export const getEntry = realGetEnry;